import React from 'react';
import PropTypes from 'prop-types';
import ModalSupportNew from './ModalSupportNew';
import ModalAccountSwitcher from './ModalAccountSwitcher';

const HeaderModals = ({
  activeModal,
  closeModal,
  isModalOpen,
  organizationId,
  path,
}) => (
  <>
    {activeModal === 'Support' && (
      <ModalSupportNew
        path={path}
        isOpen={isModalOpen}
        onRequestClose={closeModal}
      />
    )}
    {activeModal === 'Switch Orgs' && (
      <ModalAccountSwitcher
        organizationId={organizationId}
        isOpen={isModalOpen}
        onRequestClose={closeModal}
      />
    )}
  </>
);

HeaderModals.propTypes = {
  activeModal: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  organizationId: PropTypes.string,
};

HeaderModals.defaultProps = {
  organizationId: '',
};

export default HeaderModals;
